<span class="login-block">
<a (click)="profile()" *ngIf="loggedIn" class="login"></a>
<button (click)="GoogleAuth()" *ngIf="!loggedIn" class="text-main link-btn">LOGIN</button>
</span>
